// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3sSft","sendOtp":"AuthorizeToLogin_sendOtp__1H5OF"};